import { call, put, takeLatest } from 'redux-saga/effects';
import accountManagementService from '../../../services/accountManagementService';
import {
  unlockAccount,
  unlockAccountSuccess,
  unlockAccountFailure,
  fetchLockedAccounts,
  fetchLockedAccountsSuccess,
  fetchLockedAccountsFailure,
} from './slice';

function* handleUnlockAccount(action) {
  try {
    const response = yield call(accountManagementService.unlockAccount, action.payload);
    yield put(unlockAccountSuccess(response));
    // Optionally refresh locked accounts list after unlock
    // yield put(fetchLockedAccounts({ keyword: '' }));
  } catch (error) {
    yield put(unlockAccountFailure(error.message));
  }
}

function* handleFetchLockedAccounts(action) {
  try {
    const keyword = action.payload?.keyword || '';
    const response = yield call(accountManagementService.getLockedAccounts, keyword);
    yield put(fetchLockedAccountsSuccess(response));
  } catch (error) {
    yield put(fetchLockedAccountsFailure(error.message));
  }
}

export function* watchAccountManagementActions() {
  yield takeLatest(unlockAccount.type, handleUnlockAccount);
  yield takeLatest(fetchLockedAccounts.type, handleFetchLockedAccounts);
}
